// components/News/NewsfeedCommodities.jsx
import React, { useEffect, useState } from 'react';

export default function NewsfeedCommodities() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchRSS = async () => {
      try {
        const res = await fetch(
          'https://api.rss2json.com/v1/api.json?rss_url=https://www.investing.com/rss/news_301.rss'
        );
        if (!res.ok) throw new Error('Feed not available');
        const data = await res.json();
        if (!data.items || data.items.length === 0) throw new Error('No articles found');
        setItems(data.items.slice(0, 6));
      } catch (err) {
        setError('Unable to load commodities news at the moment.');
        console.error('Commodities News RSS error:', err.message);
      }
    };

    fetchRSS();
  }, []);

  return (
    <div className="space-y-4 text-sm text-gray-200">
      {error ? (
        <p className="text-red-400 italic">{error}</p>
      ) : items.length === 0 ? (
        <p className="text-gray-500 italic">Loading commodities news...</p>
      ) : (
        items.map((item, idx) => (
          <div key={idx} className="border-b border-gray-700 pb-2">
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-yellow-400 font-semibold hover:underline"
            >
              {item.title}
            </a>
            <p className="text-xs text-gray-400 mt-1">
              {new Date(item.pubDate).toLocaleString()}
            </p>
          </div>
        ))
      )}
    </div>
  );
}
